import React from 'react';
import { Link } from 'react-router-dom';
import { Play, Briefcase, MapPin, ArrowRight } from 'lucide-react';

/**
 * CMS-powered Series Showcase component
 */
export const SeriesShowcaseCMS = ({ cmsContent = null, cmsEpisodes = [] }) => {
  // Default series data
  let sectionTitle = "Explore Our Shows";
  let sectionSubtitle = "From weekly podcasts to special series, there's something for every golf enthusiast.";
  let seriesData = [
    {
      name: "Main Show",
      description: "Weekly conversations with golf's most interesting people. Business, life, and everything in between – all through the lens of the game we love.",
      color: "#0C6951",
      icon: "play"
    },
    {
      name: "Golf + Business",
      description: "Where the fairway meets the boardroom. Exploring how golf shapes leadership, networking, and professional success.",
      color: "#DD5E42",
      icon: "briefcase"
    },
    {
      name: "Travel/Course Features",
      description: "Dream courses, bucket list destinations, and the stories behind the world's most incredible golf experiences.",
      color: "#F4A261",
      icon: "map-pin"
    }
  ];

  // If CMS content is provided, extract and merge
  if (cmsContent && cmsContent.blocksData) {
    const blocks = cmsContent.blocksData.filter(b => b.isVisible);
    
    // First block is section header
    if (blocks[0] && blocks[0].blockType === 'section_header') {
      sectionTitle = blocks[0].content.title || sectionTitle;
      sectionSubtitle = blocks[0].content.subtitle || sectionSubtitle;
    }
    
    // Remaining blocks are series
    const seriesBlocks = blocks.filter(b => b.blockType === 'text_block');
    if (seriesBlocks.length > 0) {
      seriesData = seriesBlocks.map(block => ({
        name: block.content.heading || '',
        description: block.content.body || '',
        color: block.content.metadata?.color || '#0C6951',
        icon: block.content.metadata?.icon || 'play'
      }));
    }
  }

  const getIcon = (iconName) => {
    switch (iconName) {
      case 'play':
        return <Play size={32} color="white" />;
      case 'briefcase':
        return <Briefcase size={32} color="white" />;
      case 'map-pin':
        return <MapPin size={32} color="white" />;
      default:
        return <Play size={32} color="white" />;
    }
  };

  return (
    <section className="series-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">{sectionTitle}</h2>
          <p className="body-large">{sectionSubtitle}</p>
        </div>
        
        <div className="series-grid">
          {seriesData.map((series, index) => {
            // Use only CMS episodes - no fallback to mockData
            const seriesEpisodes = cmsEpisodes.filter(ep => ep.series === series.name);
            return (
              <div key={`series-${series.name || 'item'}-${index}`} className="series-card network-card">
                <div className="series-icon" style={{ background: series.color }}>
                  {getIcon(series.icon)}
                </div>
                <h3 className="heading-3">{series.name}</h3>
                <p className="body-medium">{series.description}</p>
                <div className="series-count">{seriesEpisodes.length} Episode{seriesEpisodes.length !== 1 ? 's' : ''}</div>
                <Link to="/episodes" className="series-link">
                  View Episodes <ArrowRight size={18} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
